import { render, staticRenderFns } from "./HomeControl.vue?vue&type=template&id=be895150&scoped=true"
import script from "./HomeControl.vue?vue&type=script&lang=js"
export * from "./HomeControl.vue?vue&type=script&lang=js"
import style0 from "./HomeControl.vue?vue&type=style&index=0&id=be895150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be895150",
  null
  
)

export default component.exports